import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useScrollToAnchor() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }

    const id = hash.replace("#", "");
    
    // We add a small delay to ensure that:
    // 1. The page has rendered.
    // 2. Any 'scroll-to-top' restoration logic has finished.
    // This ensures the user sees the scroll animation starting from the top.
    const scrollToElement = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };

    // 100ms delay gives the browser time to paint the 'top' position 
    // before starting the animation.
    const timeoutId = window.setTimeout(() => {
      if (!scrollToElement()) {
        // Retry once more for slightly slower renders
        setTimeout(scrollToElement, 250);
      }
    }, 100);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [hash]);
}
